const form = {
  formId: "new-user-form",
  formField: {
    period: {
      name: "period",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    exploitationDate: {
      name: "exploitationDate",
      label: "[01a] Ngày khai thác sản lượng:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    additional: {
      name: "additional",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    //
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên tổ chức",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên tổ chức",
    },
    dateOfBirth: {
      name: "dateOfBirth",
      label: "[05] Ngày tháng năm sinh (nếu là cá nhân):",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày sinh",
    },
    taxId: {
      name: "taxId",
      label: "[06] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    identifier: {
      name: "identifier",
      label: "[07] Số CMND/hộ chiếu/CCCD:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số CMND/hộ chiếu/CCCD",
      invalidMsg: "Mã số CMND/hộ chiếu/CCCD không hợp lệ",
    },
    dateRange: {
      name: "dateRange",
      label: "[08] Ngày cấp:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày cấp",
    },
    issuedBy: {
      name: "issuedBy",
      label: "[09] Nơi cấp:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập nơi cấp",
    },
    city: {
      name: "city",
      label: "[10.6] Tỉnh/thành phố:",
      type: "text",
      errorMsg: "Vui lòng chọn thành phố",
    },
    district: {
      name: "district",
      label: "[10.5] Quận/huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận huyện",
    },
    ward: {
      name: "ward",
      label: "[10.4] Phường/xã/thị trấn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn phường",
    },
    village: {
      name: "village",
      label: "[10.3] Tổ/thôn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tổ/thôn",
    },
    road: {
      name: "road",
      label: "[10.2] Đường/phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn đường/phố",
    },
    apartment: {
      name: "apartment",
      label: "[10.1] Số nhà:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số nhà",
    },
    notificationAddress: {
      name: "notificationAddress",
      label: "[11] Địa chỉ nhận thông báo thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ nhận thông báo thuế",
    },
    phoneNumber: {
      name: "phoneNumber",
      label: "[12] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
    },
    //
    taxAgentName: {
      name: "taxAgentName",
      label: "[13] Tên tổ chức:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức",
    },
    taxAgentId: {
      name: "taxAgentId",
      label: "[14] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế đại lý",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[09] Hợp đồng đại lý thuế: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số hợp đồng đại lý thuế",
    },
    daytaxAgentContract: {
      name: "daytaxAgentContract",
      label: "Ngày:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    //
    plotAddressCity: {
      name: "plotAddressCity",
      label: "[16.6] Tỉnh/thành phố:",
      type: "text",
      errorMsg: "Vui lòng chọn thành phố",
    },
    plotAddressDistrict: {
      name: "plotAddressDistrict",
      label: "[16.5] Quận/huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận huyện",
    },
    plotAddressWard: {
      name: "plotAddressWard",
      label: "[16.4] Phường/xã/thị trấn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn phường",
    },
    plotAddressVillage: {
      name: "plotAddressVillage",
      label: "[16.3] Tổ/thôn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổ/thôn",
    },
    plotAddressRoad: {
      name: "plotAddressRoad",
      label: "[16.2] Đường/phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập đường/phố",
    },
    plotAddress: {
      name: "plotAddress",
      label: "[16.1] Số nhà:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ lô đất",
    },
    //
    address: {
      name: "address",
      label: "[17] Vị trí thửa đất/mặt nước:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số thửa",
    },
    //
    purposeOfUsingLand: {
      name: "purposeOfUsingLand",
      label: "[18] Mục đích sử dụng đất:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mục đích sử dụng đất",
    },
    acreage: {
      name: "acreage",
      label: "[19] Diện tích:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích",
    },
    startingTime: {
      name: "startingTime",
      label:
        "[20] Thời điểm sử dụng đất vào mục đích thuộc đối tượng phải nộp tiền thuê đất theo quy định của Luật Đất đai:",
      type: "number",
      errorMsg: "Vui lòng chọn thời điểm bắt đầu sử dụng đất",
    },
    //--------------//
    nonAgriculturalProductionBusiness: {
      name: "nonAgriculturalProductionBusiness",
      label: "[21] Đất/mặt nước dùng cho sản xuất kinh doanh phi nông nghiệp:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích đất/mặt nước dùng cho sản xuất kinh doanh phi nông nghiệp",
    },
    buildInfrastructure: {
      name: "buildInfrastructure",
      label: "[22] Đất xây dựng nhà ở, cơ sở hạ tầng để cho thuê:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích đất xây dựng nhà ở, cơ sở hạ tầng để cho thuê",
    },
    buildIndustrial: {
      name: "buildIndustrial",
      label: "[23] Đất xây dựng khu công nghiệp, cụm công nghiệp, làng nghề:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích đất xây dựng khu công nghiệp, cụm công nghiệp, làng nghề",
    },
    agriculturalProduction: {
      name: "agriculturalProduction",
      label: "[24] Đất/mặt nước sử dụng vào mục đích sản xuất nông nghiệp, nuôi trồng thủy sản:",
      type: "number",
      placeholder: "",
      errorMsg:
        "Vui lòng nhập diện tích đất/mặt nước sử dụng vào mục đích sản xuất nông nghiệp, nuôi trồng thủy sản",
    },
    anotherPurpose: {
      name: "anotherPurpose",
      label: "[25] Đất/mặt nước dùng vào mục đích khác:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích đất/mặt nước dùng vào mục đích khác",
    },
    landUsePeriod: {
      name: "landUsePeriod",
      label:
        "5. Thời gian sử dụng đất vào mục đích thuộc đối tượng phải nộp tiền thuê theo quy định của Luật đất đai:",
      type: "number",
      placeholder: "",
      errorMsg:
        "Vui lòng nhập thời gian sử dụng đất vào mục đích thuộc đối tượng phải nộp tiền thuê theo quy định của Luật đất đai",
    },

    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
